import styled from '@emotion/styled';
import { css } from '@emotion/react';
import { prop } from 'ramda';

import breakpoints from 'app/styles/constants/breakpoints';
import { HEADER_HEIGHT } from 'app/features/header/constants';

const { widthSmall, widthMedium } = breakpoints;

const S = {};

S.StackedLayout = styled.div`
  label: StackedLayout;

  --top-gutter: 2rem;
  --bottom-gutter: 3rem;

  ${({ hasPaddingTop }) =>
    hasPaddingTop &&
    css`
      padding-top: var(--top-gutter);
    `}

  ${({ hasMarginTop }) =>
    hasMarginTop &&
    css`
      margin-top: ${HEADER_HEIGHT};
    `}

  padding-bottom: var(--bottom-gutter);

  @media (${widthSmall}) {
    --top-gutter: 4.5rem;
    --bottom-gutter: 4.5rem;
  }

  @media (${widthMedium}) {
    --top-gutter: 6rem;
    --bottom-gutter: 6rem;
  }
`;

S.StackedLayout.ContentBlock = styled.div`
  label: ContentBlock;

  --gutter: ${prop('gutterMobile')};
  --horizontal-padding: 1.25rem;

  margin-bottom: calc(var(--gutter) * 0.0625rem);

  ${({ isContained }) =>
    isContained &&
    css`
      padding: 0 var(--horizontal-padding);
      max-width: 77.5rem;
      margin-left: auto;
      margin-right: auto;
    `}

  &:last-child {
    margin-bottom: 0;
  }

  @media (${widthSmall}) {
    --gutter: ${prop('gutterTablet')};
    --horizontal-padding: 2.5rem;
  }

  @media (${widthMedium}) {
    --gutter: ${prop('gutterDesktop')};
  }
`;

export default S;
